import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, of } from 'rxjs';

/**
 * Mock local del detalle de room (GET /organizations/rooms/:id/).
 * Sólo aplica a las rooms listadas en MOCK_ROOM_IDS y devuelve una respuesta
 * fija con notifications pobladas para poder ver el estado "wellness-warning".
 *
 * Para desactivarlo, quitar el provider en app.module.ts.
 *
 * TODO(mock): borrar este archivo entero (y su provider en app.module.ts) cuando
 * el backend devuelva notifications reales en el detalle de room.
 */
@Injectable()
export class MockRoomInterceptor implements HttpInterceptor {
  private readonly MOCK_ROOM_IDS = ['495', '532'];

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const match = req.method === 'GET' && this.matchRoomId(req.url);

    if (!match) {
      return next.handle(req);
    }

    return of(new HttpResponse({ status: 200, body: MOCK_ROOM_RESPONSE }));
  }

  private matchRoomId(url: string): string | null {
    const found = url.match(/\/organizations\/rooms\/(\d+)\/?(?:\?|$)/);
    const id = found?.[1];
    return id && this.MOCK_ROOM_IDS.includes(id) ? id : null;
  }
}

const MOCK_ROOM_RESPONSE = {
  id: 532,
  name: 'Demo Larga 2do BACH',
  description: '',
  organization: 79,
  participants_count: 32,
  student_count: 29,
  teacher: {
    id: 9905,
    first_name: 'Juan Demo',
    last_name: 'Profe',
    email: 'juan.cruz.demo.profe@gr.com',
  },
  students: [
    {
      id: 11317,
      first_name: 'Victor',
      last_name: 'Arribas Cortés',
      user_type: 'Student',
      email: 'nicaraguadosmil2@hotmail.com',
      verified: true,
      phone: '',
      image_profile_url: null,
      questionaries: [],
      progress: {
        progress_percentage: 0,
        children_completed_1: 0,
        children_total_1: 6,
        chapters: [],
      },
      notifications: [
        {
          notification_id: 90001,
          read: false,
          read_at: "",
          student_id: '11317',
          student_name: 'Victor Arribas Cortés',
          room_id: '532',
          room_name: 'Demo Larga 2do BACH',
          created_at: '04-06-2026',
        },
      ],
      has_generated_report: false,
      last_login: null,
      has_free_text_answers: true,
    },

    {
      id: 11315,
      first_name: 'Ainhara',
      last_name: 'Castro Landazuri',
      user_type: 'Student',
      email: 'silvialandazurisanchez@gmail.com',
      verified: true,
      phone: '',
      image_profile_url: null,
      questionaries: [],
      progress: {
        progress_percentage: 0,
        children_completed_1: 0,
        children_total_1: 6,
        chapters: [],
      },
      notifications: [],
      has_generated_report: false,
      last_login: null,
      has_free_text_answers: true,
    },
    {
      id: 11142,
      first_name: 'Paula',
      last_name: 'Vegas Ramos',
      user_type: 'Student',
      email: 'paulavegasramos@gmail.com',
      verified: true,
      phone: '',
      image_profile_url: null,
      questionaries: [],
      progress: {
        answered_count: 21,
        questions_count: 74,
        children_total_1: 6,
        children_total_2: 6,
        children_total_3: 16,
        children_total_4: 74,
        progress_percentage: 28.37837837837838,
        children_completed_1: 1,
        children_completed_2: 1,
        children_completed_3: 3,
        children_completed_4: 21,
        chapters: [
          { id: 1419, percentage: 100 },
          { id: 1445, percentage: 0 },
          { id: 1462, percentage: 0 },
          { id: 1478, percentage: 0 },
          { id: 1529, percentage: 0 },
          { id: 1564, percentage: 0 },
        ],
      },
      notifications: [
        {
          notification_id: 90002,
          read: false,
          read_at: null,
          student_id: '11142',
          student_name: 'Paula Vegas Ramos',
          room_id: '532',
          room_name: 'Demo Larga 2do BACH',
          created_at: '03-06-2026',
          trigger_translation: 'Respuesta de texto libre que requiere revisión',
        },
        {
          notification_id: 90003,
          read: true,
          read_at: '02-06-2026',
          student_id: '11142',
          student_name: 'Paula Vegas Ramos',
          room_id: '532',
          room_name: 'Demo Larga 2do BACH',
          created_at: '01-06-2026',
          trigger_translation: 'Bajada significativa en el progreso',
        },
      ],
      has_generated_report: false,
      last_login: null,
      has_free_text_answers: true,
    },
    {
      id: 11141,
      first_name: 'Leyre Izquierdo',
      last_name: 'Landázuri',
      user_type: 'Student',
      email: 'leyreilandazuri@gmail.com',
      verified: true,
      phone: '',
      image_profile_url: null,
      questionaries: [],
      progress: {
        progress_percentage: 0,
        children_completed_1: 0,
        children_total_1: 6,
        chapters: [],
      },
      notifications: [],
      has_generated_report: false,
      last_login: null,
      has_free_text_answers: false,
    },
    {
      id: 1047,
      first_name: 'Tatiana',
      last_name: 'Nesis',
      user_type: 'Student',
      email: 'tnesis@northfield.edu.ar',
      verified: true,
      phone: '111111',
      image_profile_url: null,
      questionaries: [],
      progress: {
        progress_percentage: 0,
        children_completed_1: 0,
        children_total_1: 6,
        chapters: [],
      },
      notifications: [
        {
          notification_id: 90004,
          read: true,
          read_at: '01-06-2026',
          student_id: '1047',
          student_name: 'Tatiana Nesis',
          room_id: '532',
          room_name: 'Demo Larga 2do BACH',
          created_at: '02-06-2026',
          trigger_translation: 'Indicador de bienestar por debajo del umbral',
        },
      ],
      has_generated_report: false,
      last_login: null,
      has_free_text_answers: true,
    },
  ],
  questionaries: [{ id: 67, name: 'Programa 6' }],
  chapters: [
    { id: 1419, name: 'Quién soy hoy para decidir' },
    { id: 1445, name: 'Intereses que guían mis pasos' },
    { id: 1462, name: 'Mis valores en acción' },
    { id: 1478, name: 'Habilidades que llevo' },
    { id: 1529, name: 'Desapego emocional' },
    { id: 1564, name: 'Mi brújula para el camino' },
  ],
  reports: [{ id: 32, name: 'Informe 2do de Bachillerato' }],
  code: '2AAYHBSB',
  waiting_requests_count: 0,
  average_progress: 37.23,
  average_chapters_completed: 2.0,
  average_chapters_total: 6,
};
